import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

const BundleVersionContext = createContext({});

export const BundleVersionProvider = ({ closed, children }) => {
  const [open, setOpen] = useState(!closed);
  const toggleIsOpen = () => setOpen(!open);

  return (
    <BundleVersionContext.Provider
      value={{
        isOpen: open,
        toggleIsOpen,
      }}
    >
      {children}
    </BundleVersionContext.Provider>
  );
};

BundleVersionProvider.propTypes = {
  children: PropTypes.node.isRequired,
  closed: PropTypes.bool,
};

BundleVersionProvider.defaultProps = {
  closed: false,
};

export const useBundleVersionContext = () => useContext(BundleVersionContext);
